<template>
    <div>
        <b-form-group
                :label="labelByInstance"
                :label-for="`id_${field._id}`"
                :class="{
                'required-field': requiredFields,
            }"
        >
            <b-form-input
                    :id="`id_${field._id}`"
                    v-model="model"
                    v-validate="{
                    required: requiredFields,
                    email: !!field.isEmail,
                    numeric: !!field.isNumeric,
                    alpha_spaces: field.isAlphaSpaces ? field.isAlphaSpaces : false,
                    confirmed:
                        field.key == 'contactInfo.confirmEmail'
                            ? this.$store.state.registration.form.contactInfo
                                  .email
                            : model,
                    regex: field.key == 'basicInfo.lastName' ? allExceptSpecialCharacters : /^/,
                    max: maxLength,
                    min: minLength,
                }"
                    type="text"
                    autocomplete="no"
                    :placeholder="placeholderCheck"
                    :disabled="loading || isDisabled"
                    :data-vv-name="labelByInstance"
                    :readonly = readOnly
                    :class="{
                    'is-invalid': errors.has(labelByInstance),
                }"
            ></b-form-input>
        </b-form-group>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    export default {
        /*
        |--------------------------------------------------------------------------
        | Component > inject
        |--------------------------------------------------------------------------
        */
        inject: {
            $validator: '$validator',
        }, // End of Component > inject

        /*
        |--------------------------------------------------------------------------
        | Component > components
        |--------------------------------------------------------------------------
        */
        components: {}, // End of Component > components

        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        props: {
            field: {
                type: Object,
                required: true,
            },
        }, // End of Component > props

        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
        data() {
            return {
                readOnly:false,
                value: '',
                isDisabled: false,
                country:process.env.VUE_APP_COUNTRY,
                modelget: '',      //using modelget only to force vue a recalculation of model
                allExceptSpecialCharacters: /^[^!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/,
                fieldsToCheck:[
                    {
                        field:'fatcaInfo.powerAttorneyName',
                        dependency:'fatcaInfo.isPowerAttorney'
                    },
                    {
                        field:'fatcaInfo.powerAttorneyAddress',
                        dependency:'fatcaInfo.isPowerAttorney'
                    },
                    {
                        field:'minorAccountInfo.name',
                        dependency:'minorAccountInfo.isMinorAccount'
                    },
                    {
                        field:'minorAccountInfo.email',
                        dependency:'minorAccountInfo.isMinorAccount'
                    },
                    {
                        field:'minorAccountInfo.address',
                        dependency:'minorAccountInfo.isMinorAccount'
                    },
                    {
                        field:'minorAccountInfo.relation',
                        dependency:'minorAccountInfo.isMinorAccount'
                    },
                    {
                        field:'minorAccountInfo.idNumber',
                        dependency:'minorAccountInfo.isMinorAccount'
                    },
                    {
                        field:'minorAccountInfo.phoneNumber',
                        dependency:'minorAccountInfo.isMinorAccount'
                    },
                    {
                        field:'jointAccountInfo.name',
                        dependency:'jointAccountInfo.isJointAccount'
                    },
                    {
                        field:'jointAccountInfo.email',
                        dependency:'jointAccountInfo.isJointAccount'
                    },
                    {
                        field:'jointAccountInfo.address',
                        dependency:'jointAccountInfo.isJointAccount'
                    },
                    {
                        field:'jointAccountInfo.relation',
                        dependency:'jointAccountInfo.isJointAccount'
                    },
                    {
                        field:'jointAccountInfo.idNumber',
                        dependency:'jointAccountInfo.isJointAccount'
                    },
                    {
                        field:'jointAccountInfo.phoneNumber',
                        dependency:'jointAccountInfo.isJointAccount'
                    },
                ],
            }
        }, // End of Component > data

        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        //    contactInfo.city
        created() {
            if(this.$store.state.registration.form.uaePassDetails)
            {
                if(this.field.key == 'basicInfo.firstName' && this.$store.state.registration.form.uaePassDetails.fullnameEN)
                {
                    this.readOnly=true
                }
                if(this.field.key == 'identityInfo.number' && this.$store.state.registration.form.uaePassDetails.idn)
                {
                    this.readOnly=true
                }
            }

            if (process.env.VUE_APP_COUNTRY != 'Pakistan') {
                if (this.field.key == 'contactInfo.city') {
                    this.$store.watch(
                        (state) => {
                            return this.$store.state.registration.form.contactInfo
                                .state // could also put a Getter here
                        },
                        (newValue, oldValue) => {
                            if (newValue == '*Non UAE') {
                                this.field.isRequired = false
                                this.isDisabled = false
                            }
                            else if(!this.$route.includes('edit-profile')) {
                                this.isDisabled = false
                                this.field.isRequired = false
                                this.$store.commit('updateField', {
                                    key: this.field.key,
                                    value: null,
                                })
                            }
                        }
                    )
                }
            }
            const fieldFound = this.fieldsToCheck ? this.fieldsToCheck.find(fieldObj => fieldObj.field === this.field.key) : null;


            if (fieldFound) {

                this.$store.watch(
                    (state) => {
                        let fieldName = fieldFound.dependency.split('.')
                        return this.$store.state.registration.form[fieldName[0]][fieldName[1]] // could also put a Getter here

                    },
                    (newValue, oldValue) => {
                        if (newValue == 'yes') {
                            this.isDisabled = false//!this.isDisabled
                            // this.field.isRequired = true
                        } else {
                            this.isDisabled = true//!this.isDisabled
                            this.model=''
                            // this.field.isRequired = false
                        }
                    }
                )
            }

        }, // End of Component > methods
        computed: {
            ...mapGetters(['loading','form','getField']),

            model: {
                /**
                 * Getter to get value for computed property
                 * using props from parent componennt
                 *
                 * @return {mix}
                 */
                get: function () {

                    if (this.field.isLocked) {
                        this.modelget = this.value     //using modelget only to force vue a recalculation of model
                        return this.$store.getters.getField(this.field.key)
                    } else {
                        let customInfo = this.$store.getters.getField(`customInfo`)
                        return customInfo && customInfo[this.field._id]
                            ? customInfo[this.field._id].value
                            : null
                    }
                }, // End of get() method
                /**
                 * Setter to set value for computed property
                 * notifying the parent component
                 *
                 * @return {void}
                 */
                set: function (newValue) {
                    this.value = newValue
                    if (this.field.isLocked) {
                        this.$store.commit('updateField', {
                            key: this.field.key,
                            value: newValue,
                        })
                    } else {
                        this.$store.commit('updateField', {
                            key: `customInfo.${this.field._id}`,
                            value: {
                                title: this.field.label,
                                type: this.field.type,
                                value: newValue,
                            },
                        })
                    }
                }, // End of set() method
            },
            minLength() {
                if(this.customerType == 'company' && this.field.key == 'identityInfo.number' && this.country == 'Pakistan')
                {
                    return 7              
                }
                return this.field.minLength
            },
            maxLength() {
                if(this.customerType == 'company' && this.field.key == 'identityInfo.number' && this.country == 'Pakistan')
                {
                    return 7              
                }
                return this.field.maxLength
            },
            requiredFields()
            {
                if((this.field.key == 'contactInfo.email' || this.field.key == 'contactInfo.confirmEmail'))
                {
                    if (this.$route.path.includes('self-register') || this.$route.path.includes('self-register-company') || this.$route.path.includes('edit-profile'))
                    {
                        return false
                    }
                    return this.field.isRequired
                }
                if(this.field.key == 'identityInfo.number' && this.country == 'Pakistan' && (this.$store.getters.form.type =='company' || this.$route.path.includes('company') && !this.$route.path.includes('register-company')))
                {
                    return true
                }

                if(["accountInfo.productOffered"].includes(this.field.key) 
                    && this.field.isRequired &&(( this.getField('type') && this.getField('type') =='individual') 
                    || (!this.$route.path.includes('company') && !this.$route.path.includes('self-register-company') 
                        && !this.$route.path.includes('edit-profile') && !this.$route.path.includes('deep-register'))))
                 { 
                   return false
                 }
                return this.field.isRequired
            },
            labelByInstance() {
                // field.label
                // if(this.$route.name=="self-registration-company-setup-profile")
                if(this.$route.path.includes('company') || this.$store.getters.form.type=='company')
                {
                    if (this.field.key == 'basicInfo.firstName') {
                        return 'Company Name'
                    }
                    if (this.field.key == 'identityInfo.number') {
                        if(process.env.VUE_APP_COUNTRY_TEMP=='UK')
                        {
                            return 'Company Registration Number'
                        }
                        else if(process.env.VUE_APP_COUNTRY_TEMP == "PK"){
                            return 'NTN number / Registration Number'
                        }
                        return 'Company Registration / Trade License Number'
                    }
                    if (this.field.key == 'identityInfo.passport.number') {
                       
                        if(process.env.VUE_APP_COUNTRY_TEMP == "PK"){
                            return 'CUIN Number / Registration Number'
                        }
                    }
                    else
                    {
                        return this.field.label
                    }

                }
                else
                {
                    return this.field.label
                }

            },
            placeholderCheck()
            {
                if(this.$route.path.includes('company') || this.$store.getters.form.type=='company')
                {
                    if (this.field.key == 'basicInfo.firstName')
                    {
                        return 'Enter Company Name'
                    }
                    if (this.field.key == 'identityInfo.number') {
                        return 'Enter number'
                    }
                    else
                    {
                        return this.field.placeholder
                    }

                }
                else
                {
                    return this.field.placeholder
                }

            },
            customerType(){
                   return this.form.type
             },
        }, // End of Component > methods

        /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
        mounted() {
            // initialize if custom field
            if (!this.field.isLocked) {
                this.$store.commit('initCustomField', {
                    key: `${this.field._id}`,
                    value: {
                        title: this.field.label,
                        type: this.field.type,
                        value: null,
                    },
                })
            }

            if (this.field.section == 'setup-profile') {
                if (
                    (this.field.key == 'contactInfo.email' ||
                        this.field.key == 'contactInfo.confirmEmail') && (this.$route.path.includes('deep'))
                ) {
                    this.isDisabled = true
                } else {
                    this.isDisabled = false
                }
            }

            var some = this.field.key.split('.')

            if (this.field.customerDetails && this.field.customerDetails[some[0]][some[1]]&&
                this.field.key!='sourceOfWealth.evidenceDocument.fileName' &&
                this.field.key!='sourceOfFunds.evidenceDocument.fileName' ){
                if(some.length==3)
                {
                    let temp = this.field.customerDetails[some[0]][some[1]]
                    this.model = temp[some[2]]
                }
                else
                {
                    this.model = this.field.customerDetails[some[0]][some[1]]
                }
                if(this.field.key == 'basicInfo.firstName' && this.field.customerDetails[some[0]][some[1]]){
                    this.isDisabled = true
                }

            }
            if(this.$route.path.includes('edit-profile') && this.field.customerDetails && this.field.customerDetails['contactInfo']['email']){
                if (this.field.key == 'contactInfo.confirmEmail'){
                    this.model = this.field.customerDetails['contactInfo']['email']
                }
            }
            const fieldFound = this.fieldsToCheck ? this.fieldsToCheck.find(fieldObj => fieldObj.field === this.field.key) : null;
            if(fieldFound)
            {
                let fieldName = fieldFound.dependency.split('.')
                if(this.$store.state.registration.form[fieldName[0]][fieldName[1]]=='yes')
                {
                    this.isDisabled = false//!this.isDisabled
                    // this.field.isRequired = true
                }
                else
                {
                    this.isDisabled = true//!this.isDisabled
                    // this.field.isRequired = false
                }
            }
        }, // End of Component > computed

        /*
        |--------------------------------------------------------------------------
        | Component > methods
        |--------------------------------------------------------------------------
        */
        methods: {}, // End of Component > mounted
    }
</script>
